import { render, staticRenderFns } from "./MeasurementCommentsBody.vue?vue&type=template&id=21e9352c&"
import script from "./MeasurementCommentsBody.vue?vue&type=script&lang=js&"
export * from "./MeasurementCommentsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports